import { OffsiteCampaign } from 'models/offsite/Campaign/OffsiteCampaign';
import { useQueryClient } from 'react-query';

export function useBulkRetargetingCampaignsCache(siteId: string) {
  const queryClient = useQueryClient();
  const addCampaignToCache = (newCampaign: OffsiteCampaign) => {
    queryClient.setQueryData(['bulk-retargeting-campaigns', siteId], (old: OffsiteCampaign[] = []) => [
      newCampaign,
      ...old,
    ]);
  };
  return { addCampaignToCache };
}
